import React from 'react'
import { Button, NavBar } from 'antd-mobile'
import classnames from 'classnames'
import { postMessage } from '../../../utils'
// import { handleClassNames } from '../../../components_renew/HOC'

// todo 这里的classNames处理感觉有点多余，要再想想
// @handleClassNames('h-full flex flex-col')
const Container = props => {
  const { className, ...others } = props
  const cs = classnames('h-screen flex flex-col', className)
  return <div className={cs} style={{ backgroundColor: 'var(--adm-color-fill-content)' }} {...others}></div>
}

// @handleClassNames('flex-shrink-0')
const Nav = props => {
  const { className, right, ...others } = props
  const cs = classnames('flex-shrink-0', className)

  const onBack = () => {
    postMessage({ type: 'back' })
  }

  // 无用函数
  // const onClose = () => {
  //   postMessage({ type: 'close' })
  // }

  // rightContent
  let rightContent = undefined
  if (process.env['REACT_APP_BUILD_ENV'] === 'development' && !right) {
    rightContent = <div>
      <Button size={'mini'} onClick={() => {
        document.documentElement.setAttribute(
          'data-prefers-color-scheme',
          'dark'
        )
      }}>dark</Button>
      <Button size={'mini'} onClick={() => {
        document.documentElement.setAttribute(
          'data-prefers-color-scheme',
          'light'
        )
      }}>light</Button>
    </div>
  } else {
    rightContent = right
  }

  return <NavBar className={cs}
                 style={{ backgroundColor: 'var(--adm-color-background)' }}
                 onBack={onBack}
                 right={rightContent}
                 {...others} />
}

// @handleClassNames('flex-grow')
const Wrapper = props => {
  const { className, ...others } = props
  const cs = classnames('flex-grow', className)
  return <div className={cs} {...others}></div>
}

export {
  Container,
  Nav,
  Wrapper
}